import { template as template_3244d2f8ff8246e48e08e17b232b61bc } from "@ember/template-compiler";
import { THREED_MIMES, IMAGE_MIMES, VIDEO_MIMES, ALLOWED_EXTENSION_MAPPINGS } from 'eflex/constants/file-types';
import getUrlType from 'eflex/util/get-url-type';
import Component from '@glimmer/component';
import { task, timeout } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { modifier } from 'ember-modifier';
import { isTesting, macroCondition } from '@embroider/macros';
import { t } from 'ember-intl';
import { CreateViewerForCanvas } from '@babylonjs/viewer';
import { tracked } from '@glimmer/tracking';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
class ThreeDViewer extends Component {
    #previousUrl;
    #viewer;
    #didSetup = false;
    willDestroy() {
        super.willDestroy(...arguments);
        this.#viewer?.dispose();
    }
    setup = modifier((element, [url])=>{
        if (macroCondition(isTesting())) {
            return;
        }
        if (this.#didSetup && this.#previousUrl === url) {
            return;
        }
        this.#didSetup = true;
        this.#previousUrl = url;
        this.#viewer?.dispose();
        this._renderViewer.perform(element, url);
    });
    _renderViewer = task({
        enqueue: true
    }, waitFor(async (element, url)=>{
        this.#viewer = await CreateViewerForCanvas(element, {
            cameraAutoOrbit: {
                enabled: false
            }
        });
        this.#viewer.loadModel(url);
    }));
    static{
        template_3244d2f8ff8246e48e08e17b232b61bc(`
      <div class="threed-outer-wrapper h-100 w-100">
        <div class="threed-inner-wrapper h-100 w-100">
          <canvas
            class="threed-viewer h-100 w-100"
            {{this.setup @url}}
          />
        </div>
      </div>
    `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
const isPdf = (type)=>type.includes('pdf');
const isSvg = (type)=>type.includes('svg');
const isImage = (type)=>IMAGE_MIMES.some((extension)=>type.includes(extension));
const is3d = (type)=>THREED_MIMES.some((extension)=>type.includes(extension));
const isVideo = (type)=>VIDEO_MIMES.some((videoType)=>type.includes(videoType));
const isAllowed = (type)=>Object.values(ALLOWED_EXTENSION_MAPPINGS).some((extension)=>type.includes(extension));
export default class UrlViewer extends Component {
    #previousUrl;
    @tracked
    type;
    setupUrlType = task(waitFor(async (component, [url])=>{
        // prevents pdfs not loading from blocked event loop
        await timeout(0);
        if (url == null) {
            return;
        }
        if (url != this.#previousUrl) {
            this.#previousUrl = url;
            // forces a refresh for PDFs with the same file but different page numbers
            this.type = '';
            this.type = await getUrlType(url);
        }
    }));
    static{
        template_3244d2f8ff8246e48e08e17b232b61bc(`
    <div
      class="w-100 h-100"
      {{didInsert this.setupUrlType.perform @url}}
      {{didUpdate this.setupUrlType.perform @url}}
     >
      {{#if this.type}}
        {{#if (isPdf this.type)}}
          <div class="w-100 h-100">
            <object class="w-100 h-100" data={{@url}} type="application/pdf"></object>
          </div>
        {{else if (is3d this.type)}}
          <ThreeDViewer @url={{@url}} />
        {{else if (isVideo this.type)}}
          <video
            src={{@url}}
            type={{this.type}}
            autoplay
            controls
            class="url-viewer-video"
          ></video>
        {{else if (isImage this.type)}}
          <img src={{@url}} class="img-responsive img-fluid" />
        {{else if (isSvg this.type)}}
          <object data={{@url}} type="image/svg+xml"></object>
        {{else if (isAllowed this.type)}}
          <iframe class="w-100 h-100" src={{@url}}></iframe>
        {{else}}
          <div class="text-center">
            {{t "fileCannotBeDisplayed" }}
          </div>
        {{/if}}
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
